import {
  INotification,
  INotificationFlyerPageTarget,
} from "../../../../types/notification/inotification.interface";
import { getResourceLink } from "../pages.functions";
import { Nullable } from "../../../../types/common";
import {
  NotificationRouteHandler,
  NotificationRouteHandlerConfig,
} from "./notification-route-handler-config.interface";
import { BasicResourceType } from "../../../../types/resources/resources.enums";

export function getNotificationResourceRoute(notification: INotification): Nullable<string> {
  const handler = getNotificationRouteHandler(notification);
  return handler(notification);
}

function getNotificationRouteConfigHandlers(): NotificationRouteHandlerConfig[] {
  return [
    {
      resourceType: BasicResourceType.FlyerPage,
      handler: flyerPageNotificationRouteHandler,
    },
  ];
}

const flyerPageNotificationRouteHandler = (notification: INotification): Nullable<string> =>
  `/flyer/${(notification.target as INotificationFlyerPageTarget).flyerId}/page/${
    notification.target.id
  }`;

function getNotificationRouteHandler(notification: INotification): NotificationRouteHandler {
  const config = getNotificationRouteConfigHandlers().find(
    (config) => config.resourceType === notification.target.resourcetype
  );
  if (config) {
    return config.handler;
  }
  return defaultNotificationRouteHandler;
}

const defaultNotificationRouteHandler = (notification: INotification): Nullable<string> =>
  getResourceLink(notification.target.id, notification.target.resourcetype);
